module.exports = __webpack_public_path__ + "img/tech_image_9_2.4b3bbe55.jpg";